import { render, staticRenderFns } from "./SelectAdminHub.vue?vue&type=template&id=63bd1bb6&"
import script from "./SelectAdminHub.vue?vue&type=script&lang=js&"
export * from "./SelectAdminHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports